import { createSelector } from '@reduxjs/toolkit';

import { selectCompanyUsers } from '../user';

export const selectActiveScope = (state) => state.activeContext.activeScope;

export const selectActiveCompanyId = (state) => state.activeContext.selectedCompanyId;

export const selectActiveCompany = createSelector(
	[selectCompanyUsers, selectActiveCompanyId],
	(companyUsers, selectedId) => companyUsers.find((c) => c.id === selectedId) || null,
);

export const selectActiveCompanyName = createSelector(
	[selectActiveCompany],
	(company) => company?.name || '',
);
